module.exports = __webpack_public_path__ + "img/porwod_logo_white.510a2227.png";